import { cn } from "@client/lib/cn";

export type ButtonVariant = "primary" | "secondary" | "ghost";
export type ButtonSize = "md" | "lg";

// min-h-11 keeps every size at the 44px touch target (TECH.md §8.1).
const BASE =
  "relative inline-flex min-h-11 items-center justify-center gap-2 overflow-hidden rounded-lg font-medium whitespace-nowrap transition-all duration-200 ease-expo-out active:scale-[0.98] disabled:pointer-events-none disabled:opacity-50";

const VARIANTS: Record<ButtonVariant, string> = {
  primary:
    "bg-accent text-foreground shadow-accent hover:bg-accent-bright hover:shadow-accent-hover",
  secondary:
    "bg-surface text-foreground shadow-inner-highlight hover:bg-surface-hover hover:shadow-card-hover",
  ghost: "text-foreground-muted hover:bg-surface hover:text-foreground",
};

const SIZES: Record<ButtonSize, string> = {
  md: "px-4 text-sm",
  lg: "px-6 text-base",
};

export function buttonClassName(
  variant: ButtonVariant = "primary",
  size: ButtonSize = "md",
  className?: string,
): string {
  return cn(BASE, VARIANTS[variant], SIZES[size], className);
}
